
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VaccineTransactionApi } from '../api/vaccinetransaction.api';
import { switchMap, map } from 'rxjs/operators';
import { VaccineTransactionData, VaccineTransaction } from '../../../interfaces/masters/vaccinetransaction' ;
@Injectable()
export class VaccineTransactionService extends VaccineTransactionData {

    constructor(private api: VaccineTransactionApi) {
      super();
    }
  
  
    list(url: string): Observable<VaccineTransaction[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<VaccineTransaction>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<VaccineTransaction[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:VaccineTransaction): Observable<VaccineTransaction> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  